function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M4.414 11.999H5v6.999a1 1 0 0 0 1 1h4v-6h3.999v6h3.999a1 1 0 0 0 1-1v-7h.585c.891 0 1.337-1.076.707-1.706l-7.585-7.585a1 1 0 0 0-1.414 0l-7.584 7.585c-.63.63-.184 1.707.707 1.707",
  clipRule: "evenodd"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/favourite/ic-home.svg";
export { SvgComponent as ReactComponent };